import { useHistory } from 'react-router-dom';
import { useSignupWizard } from './signup-wizard-context';
import { logEvent } from '../../services/eventsService';

interface StepNavigationOptions {
  currentStep: number;
  nextPath?: string;
  prevPath?: string;
  onBeforeNext?: () => Record<string, any>;
  validate?: () => boolean;
  eventName?: string;
}

export function useStepNavigation({ currentStep, nextPath, prevPath, onBeforeNext, validate, eventName }: StepNavigationOptions) {
  const history = useHistory();
  const { state, updateState, completeStep, setCurrentStep } = useSignupWizard();

  const handleNext = () => {
    if (validate && !validate()) return;
    if (onBeforeNext) {
      const data = onBeforeNext();
      updateState(data);
    }
    completeStep(currentStep);
    if (eventName) {
      logEvent({ event: eventName, metadata: { sessionId: state.sessionId } });
    }
    if (nextPath) {
      setCurrentStep(currentStep + 1);
      history.push(nextPath);
    }
  };

  const handleBack = () => {
    if (prevPath) history.push(prevPath);
  };

  return { handleNext, handleBack };
}
